import { createFileRoute } from "@tanstack/react-router";
import { GlobalAiSettingsPage } from "~/pages/GlobalAiSettingsPage";

export const Route = createFileRoute("/_dashboard/$datasetSlug/settings/global-ai-settings")({
  component: RouteComponent,
});

function RouteComponent() {
  return <GlobalAiSettingsPage />;
}
